module.exports = __webpack_public_path__ + "static/img/banner-cursos-1024x768.aa173ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-cursos-1024x768.jpg
// module id = wzzl
// module chunks = 47